import {JsonObject, JsonProperty} from "typescript-json-serializer";

@JsonObject()
export class FilterConfiguration {

    @JsonProperty()
    declare metauid: string;

    @JsonProperty()
    declare label?:  string;

    @JsonProperty()
    declare info: string[];

    @JsonProperty()
    declare datasets: FilterDataset[];

    constructor() {}
}

export class FilterDataset {

    @JsonProperty()
    declare layerId: number;

    @JsonProperty()
    declare isZoom: boolean;

    @JsonProperty()
    declare settings: FilterSetting[];

    constructor() {}
}

export class FilterSetting {

    @JsonProperty()
    declare field: string;

    @JsonProperty()
    declare fieldAlias: string;

    @JsonProperty()
    declare orderValues: boolean;

    @JsonProperty()
    declare sortByText: boolean;

    @JsonProperty()
    declare descending: boolean;

    @JsonProperty()
    declare searchable: boolean;

    constructor() {}
}
